import React, { useState, useRef, useEffect } from "react";
import { notBlank } from '~/utils/helpers'
import { aria_btn } from "~/styles/app.module.scss"
import * as styles from "~/styles/pages/faq.module.scss"

const FaqItem = ({ content, index }) => {

  const { group, question, answer } = content
  const [openStatus, setOpenStatus] = useState(false)

  const aRef = useRef(null)

  const onClicked = () => {
    setOpenStatus(!openStatus)
    aRef.current.querySelectorAll('a').forEach(x => x.setAttribute('tab-index', !openStatus === true ? '0' : '-1'))
  }

  useEffect(() => {
    if (!aRef.current) return

    aRef.current.querySelectorAll('a').forEach(x => x.setAttribute('tab-index','-1'))
  }, [])

  return (
    <li 
      data-type={group} 
      itemScope 
      itemProp="mainEntity" 
      itemType="https://schema.org/Question"
    >
      {notBlank(question) && (
        <button 
          type="button"
          id={`${group}-q-${index}`}
          className={`${aria_btn} ${styles.faq_q}`}
          itemProp="name" 
          aria-expanded={openStatus ? 'true' : 'false'}
          aria-controls={`${group}-a-${index}`} 
          onClick={onClicked}
        >
          {question}
        </button>
      )}
      {notBlank(answer) && (
        <div 
          className={styles.faq_a}
          id={`${group}-a-${index}`} 
          itemScope 
          itemProp="acceptedAnswer" 
          itemType="https://schema.org/Answer" 
          role="region" 
          aria-hidden={openStatus ? 'false' : 'true'}
          aria-labelledby={`${group}-q-${index}`} 
          ref={aRef}
          dangerouslySetInnerHTML={{ __html: answer }} 
        />
      )}
    </li>
  )
}

export default FaqItem


